module.exports = __webpack_public_path__ + "static/media/Studios.773a0121.svg";